import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

export const ldProviderBuilder = async () =>
  asyncWithLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCHDARKLY_SDK_KEY || '',
  });
